import { bind, Component, h, OmiProps, signal, tag } from "omi";

import { GemGraphic } from "@/components/atoms/nw-graphic/graphics/gem";
import { HeartsGraphic } from "@/components/atoms/nw-graphic/graphics/hearts";
import { HelloGraphic } from "@/components/atoms/nw-graphic/graphics/hello";
import { StarGraphic } from "@/components/atoms/nw-graphic/graphics/omg";
import { OmgBubbleGraphic } from "@/components/atoms/nw-graphic/graphics/omg-bubble.tsx";
import { OmgGraphic } from "@/components/atoms/nw-graphic/graphics/star";
import { YesGraphic } from "@/components/atoms/nw-graphic/graphics/yes";
import { tailwind } from "@/tailwind";

import { LightbulbGraphic } from "./graphics/lightbulb";
import { WowGraphic } from "./graphics/wow";
import { GraphicName } from "./models";

type StaticModeProps = {
  mode: "static";
  name: GraphicName;
  width?: number;
  height?: number;
};

type RandomModeProps = {
  mode: "random";
  names: GraphicName[];
};

type Props = OmiProps<StaticModeProps | RandomModeProps>;

@tag("nw-graphic")
export class NWGraphic extends Component<Props> {
  static css = [tailwind];
  static propTypes = {
    mode: String,
    name: String,
    width: Number,
    height: Number,
    names: Array,
  };
  private randomIndex = signal(0);

  private getGraphic(graphic: GraphicName, width?: number, height?: number) {
    switch (graphic) {
      case "wow":
        return <WowGraphic />;
      case "gem":
        return <GemGraphic />;
      case "hearts":
        return <HeartsGraphic />;
      case "omg":
        return <OmgGraphic />;
      case "star":
        return <StarGraphic />;
      case "yes":
        return <YesGraphic />;
      case "hello":
        return <HelloGraphic />;
      case "lightbulb":
        return <LightbulbGraphic />;
      case "omg-bubble":
        return <OmgBubbleGraphic width={width ?? 210} height={height ?? 175} />;
    }
  }

  installed() {
    if (this.props.mode === "random") {
      this.randomIndex.value = Math.floor(Math.random() * this.props.names.length);
    }
  }

  @bind
  private getRandomGraphic(options: GraphicName[], width?: number, height?: number) {
    return this.getGraphic(options[this.randomIndex.value] as GraphicName, width, height);
  }

  render() {
    if (this.props.mode === "random") {
      return this.getRandomGraphic(
        this.props.names,
        this.props.width as number | undefined,
        this.props.height as number | undefined,
      );
    }

    return this.getGraphic(this.props.name, this.props.width, this.props.height);
  }
}
